import { Modal } from "../../components/Modal";
import { formatDateTime } from "../../../utils/formatters";

interface Props {
  open: boolean;
  moduleName: string;
  configuredBy: string;
  configuredOn: number;
  updatedBy: string;
  updatedOn: number;
  onClose: () => void;
}

/** Audit details (who/when created & updated) for a scheduler row. Mirrors
 * g360's `DetailsModal`. */
export function DetailsModal({
  open,
  moduleName,
  configuredBy,
  configuredOn,
  updatedBy,
  updatedOn,
  onClose,
}: Readonly<Props>) {
  const rows: { label: string; value: string }[] = [
    { label: "Configured By", value: configuredBy || "—" },
    { label: "Configured On", value: formatDateTime(configuredOn) },
    { label: "Updated By", value: updatedBy || "—" },
    { label: "Updated On", value: formatDateTime(updatedOn) },
  ];

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={moduleName || "Details"}
      footer={
        <button
          onClick={onClose}
          className="px-4 py-2 rounded-lg border border-[#e2e8f0] dark:border-white/[0.07] text-sm font-medium text-[#475569] dark:text-white/60 hover:bg-[#f1f5f9] dark:hover:bg-white/[0.04] transition-colors"
        >
          Close
        </button>
      }
    >
      <dl className="divide-y divide-border">
        {rows.map((r) => (
          <div key={r.label} className="flex items-center justify-between py-2.5 gap-4">
            <dt className="text-sm font-medium text-foreground">{r.label}</dt>
            <dd className="text-sm text-muted-foreground text-right">{r.value}</dd>
          </div>
        ))}
      </dl>
    </Modal>
  );
}
